import React from 'react';

import useImageMetadataRetriever from './useImageMetadataRetriever.hook';

export default function SlideImage({ src, srcSet, onMetaData }) {
  const imageRef = useImageMetadataRetriever(src, onMetaData);

  return <img ref={imageRef} src={src} srcSet={srcSet} alt='Slide' />;
}
